<div class="full-size bg-{{theme.bright}} text-{{theme.brightContrast}}" [innerHTML]="htmlContent"></div>